import { render, staticRenderFns } from "./ShokurekishoSkillsheetEdit.vue?vue&type=template&id=4b8f42c4&scoped=true"
import script from "./ShokurekishoSkillsheetEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoSkillsheetEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShokurekishoSkillsheetEdit.vue?vue&type=style&index=0&id=4b8f42c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f42c4",
  null
  
)

export default component.exports